import { NgModule } from '@angular/core';
import { XSi18nService } from '@nx-fe/services';
import { PipesModule, XsI18nPipe } from '@nx-fe/pipes';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { DevicesMenuComponent } from './devices-menu/devices-menu.component';
import { DeviceIconComponent } from './device-icon/device-icon.component';
import { TooltipModule } from '@soti/tooltip';

import { CardDeviceDetailsComponent } from './device-overview/card-device-details/card-device-details.component';
import { CardDeviceStatusComponent } from './device-overview/card-device-status/card-device-status.component';
import { CardMemoryComponent } from './device-overview/card-memory/card-memory.component';
import { CardStorageComponent } from './device-overview/card-storage/card-storage.component';
import { DetailsHeaderComponent } from './device-overview/details-header/details-header.component';
import { DlgConfirmActionComponent } from './device-overview/dlg-confirm-action/dlg-confirm-action.component';
import { ViewDeviceDetailsComponent } from './view-device-details/view-device-details.component';
import { LocationComponent } from './view-device-details/location/location.component';
import { OverviewComponent } from './view-device-details/overview/overview.component';
import { TabsSwitcherComponent } from './device-overview/tabs-switcher/tabs-switcher.component';
import { ActionsMenuComponent } from './device-overview/actions-menu/actions-menu.component';
import { PopupModule } from '@soti/popup';
import { DeviceFormatterService } from './../../../../../../libs/services/device-formatter.service';
import { ReactiveFormsModule } from '@angular/forms';
import { DeviceContextService } from 'sspapp/services/device-context.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LvMapViewTypeButtonComponent } from '../../../../../did/src/app/modules/live-view/components/lv-layout/lv-structured-map/lv-map-view-type-button/lv-map-view-type-button.component';
import { MapModule } from '../../../../../../libs/map/src/lib/map.module';
import { MapZoomButtonsComponent } from './view-device-details/map/map-zoom-buttons/map-zoom-buttons.component';
import { MapViewTypeButtonComponent } from './view-device-details/map/map-view-type-button/map-view-type-button.component';
import { MapLocateDeviceButton } from './view-device-details/map/map-locate-device-button/map-locate-device-button.component';
import { MapLocateUserButton } from './view-device-details/map/map-locate-user-button/map-locate-user-button.component';
@NgModule({
  declarations: [
    DevicesMenuComponent,
    DeviceIconComponent,
    CardDeviceDetailsComponent,
    CardDeviceStatusComponent,
    CardMemoryComponent,
    CardStorageComponent,
    DetailsHeaderComponent,
    DlgConfirmActionComponent,
    ViewDeviceDetailsComponent,
    LocationComponent,
    OverviewComponent,
    ActionsMenuComponent,
    TabsSwitcherComponent,
    MapZoomButtonsComponent,
    MapViewTypeButtonComponent,
    MapLocateDeviceButton,
    MapLocateUserButton,
  ],

  imports: [
    CommonModule,
    PipesModule,
    TranslateModule,
    BrowserModule,
    PipesModule,
    RouterModule,
    PopupModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    TooltipModule,
    MapModule,
  ],
  providers: [XSi18nService, XsI18nPipe, DeviceFormatterService, DeviceContextService],

  bootstrap: [],
  exports: [
    DevicesMenuComponent,
    DeviceIconComponent,
    CardDeviceDetailsComponent,
    CardDeviceStatusComponent,
    CardMemoryComponent,
    CardStorageComponent,
    DetailsHeaderComponent,
    ViewDeviceDetailsComponent,
    LocationComponent,
    OverviewComponent,
    TabsSwitcherComponent,
  ],
})
export class DeviceModule {}
